export const useFormatAmount = (
  amount: number | string | null | undefined,
): string | null => {
  const numeric = parseAmount(amount);

  if (!Number.isFinite(numeric)) {
    return null;
  }

  const { business } = storeToRefs(useBusinessStore());
  const precision = business.value?.currency_precision ?? 2;

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(numeric);
};
